import React from "react";
import { Button } from "../../../../components";
import { useNavigate } from "react-router-dom";

import styles from "./EmptyCart.module.scss";
import cartEmptyIcon from "../../../../assets/icons/cartEmpty.svg";
import { useCurrentWidth } from "../../../../hooks";

export const EmptyCart: React.FC = () => {
  const navigate = useNavigate();
  const windowWidth = useCurrentWidth();
  const isTabletOrMobile = windowWidth <= 1024;

  return (
    <div className={styles.emptyCart}>
      <div className={styles.imageContainer}>
        <img 
          src={cartEmptyIcon}
          alt="Пустая корзина" 
          className={isTabletOrMobile ? styles.imageMobile : styles.image}
        />
      </div>
      <h3 className={styles.title}>Корзина пуста</h3>
      <p className={styles.description}>
        Выберите подходящий абонемент или арендуйте зал
      </p>
      <div className={styles.buttons}>
        <Button 
          newStyles={styles.button} 
          onClickFunc={() => navigate("/subscriptions")}
        >
          Купить абонемент
        </Button>
        <Button 
          newStyles={styles.button} 
          onClickFunc={() => navigate("/halls")}
        >
          Арендовать зал
        </Button>
      </div>
    </div>
  );
};

